import React, { useState, useRef, useEffect } from "react";
import { Layout } from "../../Globalstyles/Layout";
import Menu from "../../components/Menu";
import ArticleTypeDefiner from "../../components/ArticleTypeDefiner";
import { Container, NoticeBlock, Wrapper } from "./styles";
import { IoMdArchive } from "react-icons/io";
import { addNotice } from "../../NoticesFunctions";
import { useNavigate } from "react-router";
import { IsLoged } from "../../App";

export default function AddNotice() {
	const [articles, setArticles] = useState([]);
	const [addArticle, setAddArticle] = useState(false);

	const [articleType, setArticleType] = useState(null);
	const [qtdTopics, setQtdTopics] = useState(0);
	const [topics, setTopics] = useState([]);
	const [articleImageURL, setArticleImageURL] = useState("");
	const [videoURL, setVideoURL] = useState("");
	const [articleTitle, setArticleTitle] = useState("");
	const [articleDesc, setArticleDesc] = useState("");

	const [image, setImage] = useState(null);
	const [coverURL, setCoverURL] = useState("");
	const [title, setTitle] = useState("");
	const [shortDesc, setShortDesc] = useState("");
	const [description, setDescription] = useState("");
	const inputRef = useRef(null);

	const imageAcceptedFormats = ["image/jpeg", "image/jpg", "image/png"];
	const maxImageSize = 2 * 1024 * 1024;

	const navigate = useNavigate();

	useEffect(() => {
		if (!IsLoged()) return navigate("/login");
	});

	const validateImageFile = (file) => {
		if (!imageAcceptedFormats.includes(file.type)) {
			alert("Formato inválido! Apenas PNG/JPG/JPEG.");
			return false;
		}
		if (file.size > maxImageSize) {
			alert("Arquivo muito grande! Máximo 2MB.");
			return false;
		}
		return true;
	};

	const verifyImage = (file) => {
		if (!file || !validateImageFile(file)) return;

		const img = new Image();
		img.onload = () => {
			if (img.width !== 250 || img.height !== 400) {
				alert("A imagem deve ter exatamente 250×400px.");
				return;
			}
			setImage(file);
			createCoverURL(file);
		};
		img.src = URL.createObjectURL(file);
	};

	async function createCoverURL(file) {
		const formData = new FormData();
		formData.append("file", file);
		formData.append("upload_preset", "free_upload");

		try {
			const res = await fetch(
				"https://api.cloudinary.com/v1_1/dxk06cdb4/image/upload",
				{
					method: "POST",
					body: formData,
				}
			);

			const data = await res.json();
			setCoverURL(data.secure_url);
			console.log("URL da imagem:", data.secure_url);
		} catch (error) {
			console.error("Erro ao enviar imagem:", error);
		}
	}

	const handleFilePick = (e) => verifyImage(e.target.files[0]);
	const handleDrop = (e) => {
		e.preventDefault();
		verifyImage(e.dataTransfer.files[0]);
	};
	const handleDragOver = (e) => e.preventDefault();
	const handleLabelClick = () => inputRef.current.click();

	function postNotice() {
		addNotice({ title, description, shortDesc, articles, coverURL });

		setTitle("");
		setDescription("");
		setShortDesc("");
		setArticles("");
		setCoverURL("");
	}

	return (
		<div className="app" style={{ maxHeight: "100vh", overflow: "hidden" }}>
			<Layout className="layout">
				<Menu />
				<Container className="MC">
					<Wrapper>
						<div className="top">
							<h1>Adicionar notícia</h1>

							<div className="banner-define">
								<div className="info">
									<div>
										<h2>Capa da notícia</h2>
										<label
											className="upload-button"
											onClick={handleLabelClick}
											onDrop={handleDrop}
											onDragOver={handleDragOver}>
											<p>
												Escolha ou solte a imagem <IoMdArchive />
											</p>
											<p id="secondary">(250×400px • até 2MB)</p>

											<input
												type="file"
												accept="image/jpeg, image/png, image/jpg"
												ref={inputRef}
												style={{ display: "none" }}
												onChange={handleFilePick}
											/>

											<span>
												{image
													? `Imagem: ${image.name}`
													: "Nenhuma imagem selecionada"}
											</span>
										</label>
									</div>

									<input
										type="text"
										placeholder="Título da notícia"
										value={title}
										onChange={(e) => setTitle(e.target.value)}
									/>

									<div className="textarea-wrapper">
										<textarea
											name="shortDesc"
											id="shortDesc"
											placeholder="Resumo da notícia (máx. 300 caracteres)"
											maxLength={287}
											value={shortDesc}
											onChange={(e) => setShortDesc(e.target.value)}
										/>
										<p>Caracteres: {shortDesc.length}</p>
									</div>
								</div>

								<div className="banner-preview">
									<h2>Preview: </h2>
									<NoticeBlock>
										<div className="notice-btn">
											{coverURL ? (
												<img src={coverURL} alt="capa da notícia" />
											) : (
												<div className="imageShadow">
													<p>imagem aparece aqui</p>
												</div>
											)}
											<div className="content">
												<h2 title={title}>{title || "Título de exemplo"}</h2>
												<div className="desc">
													<p style={{ whiteSpace: "pre-wrap" }}>
														{shortDesc || "Resumo breve da notícia..."}
													</p>
													<div className="desc-btn">Saiba mais …</div>
												</div>
											</div>
										</div>
									</NoticeBlock>
								</div>
							</div>

							<textarea
								name="description"
								id="description"
								placeholder="Descrição completa…"
								value={description}
								onChange={(e) => setDescription(e.target.value)}
							/>
						</div>

						<div className="articles-wrapper">
							<h2>Artigos</h2>

							{!articles.length ? (
								<p className="empty">Nenhum artigo adicionado ainda...</p>
							) : (
								<ul>
									{articles.map((e, index) => (
										<li key={index}>
											<span>
												{e.name || "título do artigo"} -{" "}
												{e.type || "tipo do artigo"}
											</span>
										</li>
									))}
								</ul>
							)}

							<button className="add" onClick={() => setAddArticle(true)}>
								Adicionar artigo
							</button>

							<div
								className={`addArticles-wrapper ${
									addArticle ? "visible" : ""
								}`}>
								<div className="types-wrapper">
									<h3>Tipo do artigo:</h3>
									<button onClick={() => setArticleType(1)}>
										Lista por tópicos
									</button>
									<button onClick={() => setArticleType(2)}>
										Lista numérica
									</button>
									<button onClick={() => setArticleType(3)}>
										Parágrafo com imagem
									</button>
									<button onClick={() => setArticleType(4)}>
										Parágrafo com vídeo
									</button>
								</div>

								<div className="infoAdd-area">
									<h3>
										{articleType === 1
											? "Lista de topicos"
											: articleType === 2
											? "Lista numerica"
											: articleType === 3
											? "Paragrafo com foto"
											: articleType
											? " Paragrafo com video "
											: " "}
									</h3>
									<ArticleTypeDefiner
										typeCode={articleType}
										qtdTopics={qtdTopics}
										topics={topics}
										titleArticle={articleTitle}
										descArticle={articleDesc}
										articleImageURL={articleImageURL}
										videoURL={videoURL}
										setTopics={setTopics}
										setQtdTopics={setQtdTopics}
										setArticleTitle={setArticleTitle}
										setArticleDesc={setArticleDesc}
										setArticleImageURL={setArticleImageURL}
										setVideoURL={setVideoURL}
									/>
								</div>
							</div>

							<div className="actionButtons-wrapper">
								<button
									className={addArticle ? "" : "buttonfalse"}
									id="cancel"
									onClick={() => {
										setArticleTitle("");
										setArticleDesc("");
										setTopics([]);
										setQtdTopics(0);
										setAddArticle(false);
										setArticleType(null);
										setVideoURL(null);
										setArticleImageURL(null);
									}}>
									Cancelar
								</button>
								<button
									className={`add ${addArticle ? "" : "buttonfalse"}`}
									onClick={() => {
										let content = null;

										if (articleType === 1 || articleType === 2) {
											content = topics;
										} else if (articleType === 3) {
											content = articleImageURL;
										} else if (articleType === 4) {
											content = videoURL;
										}

										const newArticle = {
											type: articleType,
											name: articleTitle || `Artigo ${articles.length + 1}`,
											description: articleDesc,
											content,
										};

										setArticles((prev) => [...prev, newArticle]);

										setArticleTitle("");
										setArticleDesc("");
										setTopics([]);
										setQtdTopics(0);
										setAddArticle(false);
										setArticleType(null);
										setVideoURL(null);
										setArticleImageURL(null);
									}}>
									Adicionar
								</button>
							</div>
						</div>

						<button className="publish-button" onClick={() => postNotice()}>
							Publicar
						</button>
					</Wrapper>
				</Container>
			</Layout>
		</div>
	);
}
